// Dependencies
import React, { Component } from 'react';
import RegistrationFormStepTitleComponent from '../form-step-title/form-step-title';

// Primereact imports
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

// Multi lang
import { getLanguage, withTranslation } from 'react-multi-lang';

// Styling
import './step-8.scss';

// Redux
import { connect } from 'react-redux';
import { updateFormStep, updateStep8State } from '../../../redux/actions/form';

// Utils
import { getFormValue } from '../../../common/utils/form-utils';
import { FORM_FIELD_BUSINESS_NAME, FORM_FIELD_BUSINESS_OWNER, FORM_FIELD_ETHICS_COMMITTEE_BEGIN_DATE, FORM_FIELD_ETHICS_COMMITTEE_END_DATE, FORM_FIELD_ETHICS_COMMITTEE_ROLE, FORM_FIELD_ETHICS_COMMITTEE_WORKPLACE, FORM_FIELD_HAS_ETHICS_COMMITTEE_ROLE, FORM_FIELD_HAS_MANAGEMENT_ROLE, FORM_FIELD_HAS_ORGANIZATIONAL_ROLE, FORM_FIELD_HAS_PUBLIC_ADMIN_ROLE, FORM_FIELD_HAS_QUALITY_COMMITTEE_ROLE, FORM_FIELD_MANAGEMENT_BEGIN_DATE, FORM_FIELD_MANAGEMENT_END_DATE, FORM_FIELD_MANAGEMENT_PROFESSIONALS_NUMBER, FORM_FIELD_MANAGEMENT_ROLE, FORM_FIELD_MANAGEMENT_WORKPLACE, FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE, FORM_FIELD_ORGANIZATIONAL_END_DATE, FORM_FIELD_ORGANIZATIONAL_WORKPLACE, FORM_FIELD_PROFESSIONALS_NUMBER, FORM_FIELD_PUBLIC_ADMIN_BEGIN_DATE, FORM_FIELD_PUBLIC_ADMIN_BEGIN_DATE_1, FORM_FIELD_PUBLIC_ADMIN_END_DATE, FORM_FIELD_PUBLIC_ADMIN_ROLE, FORM_FIELD_PUBLIC_ADMIN_WORKPLACE, FORM_FIELD_QUALITY_COMMITTEE_BEGIN_DATE, FORM_FIELD_QUALITY_COMMITTEE_END_DATE, FORM_FIELD_QUALITY_COMMITTEE_ROLE, FORM_FIELD_QUALITY_COMMITTEE_WORKPLACE, FORM_STEP_8_STATE, REGISTRATION_STATE_REVISION, STEP_STATE_SUBMITTED, STEP_STATE_VALIDATION_ERROR, YES_OPTION } from '../../../common/constants';
import { formatYesNoDropdownLists, getYesNoDropdownList } from '../../../common/utils/form-data-utils';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';

class RegistrationFormStep8Component extends Component {

    constructor(props) {
        super(props);
        this.state = {
            addEthicsMode: false,
            addManagementMode: false,
            addPublicAdminMode: false,
            addQualityMode: false,
            addOrganizationalMode: false,
            businessOwner: false,
            businessName: "",
            professionalsNumber: null,
            hasManagementRole: false,
            hasPublicAdminRole: false,
            hasEthicsCommitteeRole: false,
            hasQualityCommitteeRole: false,
            hasOrganizationalRole: false,
            managementRoles: [],
            publicAdminRoles: [],
            ethicsCommitteeRoles: [],
            qualityCommitteeRoles: [],
            organizationalRoles: [],
            // Cursor variables
            cursorManagementRole: "",
            cursorManagementWorkplace: "",
            cursorManagementProfessionalsNumber: "",
            cursorManagementBeginDate: null,
            cursorManagementEndDate: null,
            cursorPublicAdminRole: "",
            cursorPublicAdminWorkplace: "",
            cursorPublicAdminBeginDate: null,
            cursorPublicAdminEndDate: null,
            cursorEthicRole: "",
            cursorEthicWorkplace: "",
            cursorEthicBeginDate: null,
            cursorEthicEndDate: null,
            cursorQualityRole: "",
            cursorQualityWorkplace: "",
            cursorQualityBeginDate: null,
            cursorQualityEndDate: null,
            cursorOrganizationalWorkplace: "",
            cursorOrganizationalBeginDate: null,
            cursorOrganizationalEndDate: null,
            // Mandatory fields validation
            validBusinessName: true,
            validProfessionalsNumber: true,
            validManagementRole: true,
            validManagementProfessionalsNumber: true,
            validManagementWorkplace: true,
            validManagementBeginDate: true,
            validPublicAdminRole: true,
            validPublicAdminWorkplace: true,
            validPublicAdminBeginDate: true,
            validEthicRole: true,
            validEthicBeginDate: true,
            validEthicWorkplace: true,
            validQualityBeginDate: true,
            validQualityRole: true,
            validQualityWorkplace: true,
            validOrganizationalBeginDate: true,
            validOrganizationalWorkplace: true,
            // Management roles validation 
            validManagementRolesRole: [true, true, true],
            validManagementRolesWorkplace: [true, true, true],
            validManagementRolesBeginDate: [true, true, true],
            validManagementRolesProfessionalsNumber: [true, true, true],
            // Public admin roles validation 
            validPublicAdminRolesRole: [true, true, true],
            validPublicAdminRolesWorkplace: [true, true, true],
            validPublicAdminRolesBeginDate: [true, true, true],
            // Ethic roles validation 
            validEthicRolesRole: [true, true, true],
            validEthicRolesWorkplace: [true, true, true],
            validEthicRolesBeginDate: [true, true, true],
            // Quality roles validation 
            validQualityRolesRole: [true, true, true],
            validQualityRolesWorkplace: [true, true, true],
            validQualityRolesBeginDate: [true, true, true],
            // Organizational roles validation 
            validOrganizationalRolesWorkplace: [true, true, true, true, true, true, true, true, true, true],
            validOrganizationalRolesBeginDate: [true, true, true, true, true, true, true, true, true, true]
        }
    }

    componentDidMount() {
        this.setState({
            businessOwner: formatYesNoDropdownLists(getFormValue(FORM_FIELD_BUSINESS_OWNER, this.props.formFields), this.props.language),
            businessName: getFormValue(FORM_FIELD_BUSINESS_NAME, this.props.formFields),
            professionalsNumber: getFormValue(FORM_FIELD_PROFESSIONALS_NUMBER, this.props.formFields),
            hasManagementRole: formatYesNoDropdownLists(getFormValue(FORM_FIELD_HAS_MANAGEMENT_ROLE, this.props.formFields), this.props.language),
            hasPublicAdminRole: formatYesNoDropdownLists(getFormValue(FORM_FIELD_HAS_PUBLIC_ADMIN_ROLE, this.props.formFields), this.props.language),
            hasEthicsCommitteeRole: formatYesNoDropdownLists(getFormValue(FORM_FIELD_HAS_ETHICS_COMMITTEE_ROLE, this.props.formFields), this.props.language),
            hasQualityCommitteeRole: formatYesNoDropdownLists(getFormValue(FORM_FIELD_HAS_QUALITY_COMMITTEE_ROLE, this.props.formFields), this.props.language),
            hasOrganizationalRole: formatYesNoDropdownLists(getFormValue(FORM_FIELD_HAS_ORGANIZATIONAL_ROLE, this.props.formFields), this.props.language)
        });

        let managementRoles = [];
        let publicAdminRoles = [];
        let ethicsCommitteeRoles = [];
        let qualityCommitteeRoles = [];
        let organizationalRoles = [];

        for (let i = 1; i < 4; i++) {
            if(getFormValue((FORM_FIELD_MANAGEMENT_ROLE + i.toString()), this.props.formFields) !== null) {
                managementRoles.push({
                    role: getFormValue((FORM_FIELD_MANAGEMENT_ROLE + i.toString()), this.props.formFields),
                    workplace: getFormValue((FORM_FIELD_MANAGEMENT_WORKPLACE + i.toString()), this.props.formFields),
                    beginDate: getFormValue((FORM_FIELD_MANAGEMENT_BEGIN_DATE + i.toString()), this.props.formFields),
                    endDate: getFormValue((FORM_FIELD_MANAGEMENT_END_DATE + i.toString()), this.props.formFields),
                    professionalsNumber: getFormValue((FORM_FIELD_MANAGEMENT_PROFESSIONALS_NUMBER + i.toString()), this.props.formFields)
                });
            }

            if(getFormValue((FORM_FIELD_PUBLIC_ADMIN_ROLE + i.toString()), this.props.formFields) !== null) {
                publicAdminRoles.push({
                    role: getFormValue((FORM_FIELD_PUBLIC_ADMIN_ROLE + i.toString()), this.props.formFields),
                    workplace: getFormValue((FORM_FIELD_PUBLIC_ADMIN_WORKPLACE + i.toString()), this.props.formFields),
                    beginDate: getFormValue((FORM_FIELD_PUBLIC_ADMIN_BEGIN_DATE + i.toString()), this.props.formFields),
                    endDate: getFormValue((FORM_FIELD_PUBLIC_ADMIN_END_DATE + i.toString()), this.props.formFields)
                });
            }

            if(getFormValue((FORM_FIELD_ETHICS_COMMITTEE_ROLE + i.toString()), this.props.formFields) !== null) {
                ethicsCommitteeRoles.push({
                    role: getFormValue((FORM_FIELD_ETHICS_COMMITTEE_ROLE + i.toString()), this.props.formFields),
                    workplace: getFormValue((FORM_FIELD_ETHICS_COMMITTEE_WORKPLACE + i.toString()), this.props.formFields),
                    beginDate: getFormValue((FORM_FIELD_ETHICS_COMMITTEE_BEGIN_DATE + i.toString()), this.props.formFields),
                    endDate: getFormValue((FORM_FIELD_ETHICS_COMMITTEE_END_DATE + i.toString()), this.props.formFields)
                });
            }

            if(getFormValue((FORM_FIELD_QUALITY_COMMITTEE_ROLE + i.toString()), this.props.formFields) !== null) {
                qualityCommitteeRoles.push({
                    role: getFormValue((FORM_FIELD_QUALITY_COMMITTEE_ROLE + i.toString()), this.props.formFields),
                    workplace: getFormValue((FORM_FIELD_QUALITY_COMMITTEE_WORKPLACE + i.toString()), this.props.formFields),
                    beginDate: getFormValue((FORM_FIELD_QUALITY_COMMITTEE_BEGIN_DATE + i.toString()), this.props.formFields),
                    endDate: getFormValue((FORM_FIELD_QUALITY_COMMITTEE_END_DATE + i.toString()), this.props.formFields)
                });
            }
        }

        for (let j = 1; j < 11; j++) {
            if(getFormValue((FORM_FIELD_ORGANIZATIONAL_WORKPLACE + j.toString()), this.props.formFields) !== null) {
                organizationalRoles.push({
                    role: getFormValue((FORM_FIELD_ORGANIZATIONAL_WORKPLACE + j.toString()), this.props.formFields),
                    beginDate: getFormValue((FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE + j.toString()), this.props.formFields),
                    endDate: getFormValue((FORM_FIELD_ORGANIZATIONAL_END_DATE + j.toString()), this.props.formFields)
                });
            }
        }

        this.setState({
            managementRoles: managementRoles,
            publicAdminRoles: publicAdminRoles,
            ethicsCommitteeRoles: ethicsCommitteeRoles,
            qualityCommitteeRoles: qualityCommitteeRoles,
            organizationalRoles: organizationalRoles
        });
    }

    setEthicsMode() {
        this.setState({
            addEthicsMode: true
        });
    }

    setQualityMode() {
        this.setState({
            addQualityMode: true
        });
    }

    setManagementMode() {
        this.setState({
            addManagementMode: true
        });
    }

    setOrganizationalMode() {
        this.setState({
            addOrganizationalMode: true
        });
    }

    setPublicAdminMode() {
        this.setState({
            addPublicAdminMode: true
        });
    }

    updateFormComponent(column, value) {
        this.setState({
            [column]: { key: column, value: value }
        });
    }

    validateForm() {
        let validationResult = true;

        let validBusinessName = true;
        let validProfessionalsNumber = true;

        if(this.state.businessOwner.code === YES_OPTION.code) {
            validBusinessName = (this.state.businessName !== "");
            validProfessionalsNumber = (this.state.professionalsNumber !== "");
        }

        // Existing management roles validation
        let validManagementRolesRole = [true, true, true];
        let validManagementRolesWorkplace = [true, true, true];
        let validManagementRolesBeginDate = [true, true, true];
        let validManagementRolesProfessionalsNumber = [true, true, true];

        for (let i = 0; i < validManagementRolesRole.length; i++) {
            if(i+1 > this.state.managementRoles.length) {
                validManagementRolesRole[i] = true;
                validManagementRolesWorkplace[i] = true;
                validManagementRolesBeginDate[i] = true;
                validManagementRolesProfessionalsNumber[i] = true;
            }
            else {
                validManagementRolesRole[i] = (this.state.managementRoles[i].role !== "");
                validManagementRolesWorkplace[i] = (this.state.managementRoles[i].workplace !== "");
                validManagementRolesBeginDate[i] = (this.state.managementRoles[i].beginDate !== null);
                validManagementRolesProfessionalsNumber[i] = (this.state.managementRoles[i].professionalsNumber !== "");
            }
        }

        // Existing public admin roles validation
        let validPublicAdminRolesRole = [true, true, true];
        let validPublicAdminRolesWorkplace = [true, true, true];
        let validPublicAdminRolesBeginDate = [true, true, true];

        for (let i = 0; i < validPublicAdminRolesRole.length; i++) {
            if(i+1 > this.state.publicAdminRoles.length) {
                validPublicAdminRolesRole[i] = true;
                validPublicAdminRolesWorkplace[i] = true;
                validPublicAdminRolesBeginDate[i] = true;
            }
            else {
                validPublicAdminRolesRole[i] = (this.state.publicAdminRoles[i].role !== "");
                validPublicAdminRolesWorkplace[i] = (this.state.publicAdminRoles[i].workplace !== "");
                validPublicAdminRolesBeginDate[i] = (this.state.publicAdminRoles[i].beginDate !== null);
            }
        }

        // Existing ethic roles validation
        let validEthicRolesRole = [true, true, true];
        let validEthicRolesWorkplace = [true, true, true];
        let validEthicRolesBeginDate = [true, true, true];

        for (let i = 0; i < validEthicRolesRole.length; i++) {
            if(i+1 > this.state.ethicsCommitteeRoles.length) {
                validEthicRolesRole[i] = true;
                validEthicRolesWorkplace[i] = true;
                validEthicRolesBeginDate[i] = true;
            }
            else {
                validEthicRolesRole[i] = (this.state.ethicsCommitteeRoles[i].role !== "");
                validEthicRolesWorkplace[i] = (this.state.ethicsCommitteeRoles[i].workplace !== "");
                validEthicRolesBeginDate[i] = (this.state.ethicsCommitteeRoles[i].beginDate !== null);
            }
        }

        // Existing quality roles validation
        let validQualityRolesRole = [true, true, true];
        let validQualityRolesWorkplace = [true, true, true];
        let validQualityRolesBeginDate = [true, true, true];

        for (let i = 0; i < validQualityRolesRole.length; i++) {
            if(i+1 > this.state.qualityCommitteeRoles.length) {
                validQualityRolesRole[i] = true;
                validQualityRolesWorkplace[i] = true;
                validQualityRolesBeginDate[i] = true;
            }
            else {
                validQualityRolesRole[i] = (this.state.qualityCommitteeRoles[i].role !== "");
                validQualityRolesWorkplace[i] = (this.state.qualityCommitteeRoles[i].workplace !== "");
                validQualityRolesBeginDate[i] = (this.state.qualityCommitteeRoles[i].beginDate !== null);
            }
        }

        // Existing organizational roles validation
        let validOrganizationalRolesWorkplace = [true, true, true];
        let validOrganizationalRolesBeginDate = [true, true, true];

        for (let i = 0; i < validQualityRolesRole.length; i++) {
            if(i+1 > this.state.organizationalRoles.length) {
                validOrganizationalRolesWorkplace[i] = true;
                validOrganizationalRolesBeginDate[i] = true;
            }
            else {
                validOrganizationalRolesWorkplace[i] = (this.state.organizationalRoles[i].workplace !== "");
                validOrganizationalRolesBeginDate[i] = (this.state.organizationalRoles[i].beginDate !== null);
            }
        }

        this.setState({
            validBusinessName: validBusinessName,
            validProfessionalsNumber: validProfessionalsNumber,
            validManagementRole: (this.state.addManagementMode === false || this.state.cursorManagementRole !== ""),
            validManagementProfessionalsNumber: (this.state.addManagementMode === false || this.state.cursorManagementProfessionalsNumber !== ""),
            validManagementWorkplace: (this.state.addManagementMode === false || this.state.cursorManagementWorkplace !== ""),
            validManagementBeginDate: (this.state.addManagementMode === false || this.state.cursorManagementBeginDate !== null),
            validPublicAdminRole: (this.state.addPublicAdminMode === false || this.state.cursorPublicAdminRole !== ""),
            validPublicAdminWorkplace: (this.state.addPublicAdminMode === false || this.state.cursorPublicAdminWorkplace !== ""),
            validPublicAdminBeginDate: (this.state.addPublicAdminMode === false || this.state.cursorPublicAdminBeginDate !== null),
            validEthicRole: (this.state.addEthicsMode === false || this.state.cursorEthicRole !== ""),
            validEthicWorkplace: (this.state.addEthicsMode === false || this.state.cursorEthicWorkplace !== ""),
            validEthicBeginDate: (this.state.addEthicsMode === false || this.state.cursorEthicBeginDate !== null),
            validQualityRole: (this.state.addQualityMode === false || this.state.cursorQualityRole !== ""),
            validQualityWorkplace: (this.state.addQualityMode === false || this.state.cursorQualityWorkplace !== ""),
            validQualityBeginDate: (this.state.addQualityMode === false || this.state.cursorQualityBeginDate !== null),
            validOrganizationalWorkplace: (this.state.addOrganizationalMode === false || this.state.cursorOrganizationalWorkplace !== ""),
            validOrganizationalBeginDate : (this.state.addOrganizationalMode === false || this.state.cursorOrganizationalBeginDate !== null),
            validManagementRolesRole: validManagementRolesRole,
            validManagementRolesWorkplace: validManagementRolesWorkplace,
            validManagementRolesBeginDate: validManagementRolesBeginDate,
            validManagementRolesProfessionalsNumber: validManagementRolesProfessionalsNumber,
            validPublicAdminRolesRole: validPublicAdminRolesRole,
            validPublicAdminRolesWorkplace: validPublicAdminRolesWorkplace,
            validPublicAdminRolesBeginDate: validPublicAdminRolesBeginDate,
            validEthicRolesRole: validEthicRolesRole,
            validEthicRolesWorkplace: validEthicRolesWorkplace,
            validEthicRolesBeginDate: validEthicRolesBeginDate,
            validQualityRolesRole: validQualityRolesRole,
            validQualityRolesWorkplace: validQualityRolesWorkplace,
            validQualityRolesBeginDate: validQualityRolesBeginDate,
            validOrganizationalRolesWorkplace: validOrganizationalRolesWorkplace,
            validOrganizationalRolesBeginDate: validOrganizationalRolesBeginDate
        });

        validationResult = (validBusinessName &&
                            validProfessionalsNumber &&
                            (this.state.addManagementMode === false || this.state.cursorManagementRole !== "") &&
                            (this.state.addManagementMode === false || this.state.cursorManagementProfessionalsNumber !== "") &&
                            (this.state.addManagementMode === false || this.state.cursorManagementWorkplace !== "") &&
                            (this.state.addManagementMode === false || this.state.cursorManagementBeginDate !== null) &&
                            (this.state.addPublicAdminMode === false || this.state.cursorPublicAdminRole !== "") &&
                            (this.state.addPublicAdminMode === false || this.state.cursorPublicAdminWorkplace !== "") &&
                            (this.state.addPublicAdminMode === false || this.state.cursorPublicAdminBeginDate !== null) &&
                            (this.state.addEthicsMode === false || this.state.cursorEthicRole !== "") &&
                            (this.state.addEthicsMode === false || this.state.cursorEthicWorkplace !== "") &&
                            (this.state.addEthicsMode === false || this.state.cursorEthicBeginDate !== null) &&
                            (this.state.addQualityMode === false || this.state.cursorQualityRole !== "") &&
                            (this.state.addQualityMode === false || this.state.cursorQualityWorkplace !== "") &&
                            (this.state.addQualityMode === false || this.state.cursorQualityBeginDate !== null) &&
                            (this.state.addOrganizationalMode === false || this.state.cursorOrganizationalWorkplace !== "") &&
                            (this.state.addOrganizationalMode === false || this.state.cursorOrganizationalBeginDate !== null) &&
                            this.ruleCollectionIsValid(validManagementRolesRole) &&
                            this.ruleCollectionIsValid(validManagementRolesWorkplace) &&
                            this.ruleCollectionIsValid(validManagementRolesBeginDate) &&
                            this.ruleCollectionIsValid(validManagementRolesProfessionalsNumber) &&
                            this.ruleCollectionIsValid(validPublicAdminRolesRole) &&
                            this.ruleCollectionIsValid(validPublicAdminRolesWorkplace) &&
                            this.ruleCollectionIsValid(validPublicAdminRolesBeginDate) &&
                            this.ruleCollectionIsValid(validEthicRolesRole) &&
                            this.ruleCollectionIsValid(validEthicRolesWorkplace) &&
                            this.ruleCollectionIsValid(validEthicRolesBeginDate) &&
                            this.ruleCollectionIsValid(validQualityRolesRole) &&
                            this.ruleCollectionIsValid(validQualityRolesWorkplace) &&
                            this.ruleCollectionIsValid(validQualityRolesBeginDate) &&
                            this.ruleCollectionIsValid(validOrganizationalRolesWorkplace) &&
                            this.ruleCollectionIsValid(validOrganizationalRolesBeginDate));

        return validationResult;
    }

    ruleCollectionIsValid(collection) {
        for (let i = 0; i < collection.length; i++) {
            if(collection[i] === false) return false;
        }

        return true;
    }

    submitStep() {
        if(this.validateForm()) {
            this.props.updateStep8State(STEP_STATE_SUBMITTED);

            let formValues = [
                { key: FORM_STEP_8_STATE, value: STEP_STATE_SUBMITTED },
                { key: FORM_FIELD_HAS_MANAGEMENT_ROLE, value: this.state.hasManagementRole },
                { key: FORM_FIELD_HAS_PUBLIC_ADMIN_ROLE, value: this.state.hasPublicAdminRole },
                { key: FORM_FIELD_HAS_ETHICS_COMMITTEE_ROLE, value: this.state.hasEthicsCommitteeRole },
                { key: FORM_FIELD_HAS_QUALITY_COMMITTEE_ROLE, value: this.state.hasQualityCommitteeRole },
                { key: FORM_FIELD_HAS_ORGANIZATIONAL_ROLE, value: this.state.hasOrganizationalRole },
            ]

            for (let i = 0; i < this.state.managementRoles.length; i++) {
                formValues.push({ key: (FORM_FIELD_MANAGEMENT_ROLE + i.toString()), value: this.state.managementRoles[i].role });
                formValues.push({ key: (FORM_FIELD_MANAGEMENT_WORKPLACE + i.toString()), value: this.state.managementRoles[i].workplace });
                formValues.push({ key: (FORM_FIELD_MANAGEMENT_BEGIN_DATE + i.toString()), value: this.state.managementRoles[i].beginDate });
                formValues.push({ key: (FORM_FIELD_MANAGEMENT_END_DATE + i.toString()), value: this.state.managementRoles[i].endDate });
                formValues.push({ key: (FORM_FIELD_MANAGEMENT_PROFESSIONALS_NUMBER + i.toString()), value: this.state.managementRoles[i].professionalsNumber });
            }

            for (let i = 0; i < this.state.publicAdminRoles.length; i++) {
                formValues.push({ key: (FORM_FIELD_PUBLIC_ADMIN_ROLE + i.toString()), value: this.state.publicAdminRoles[i].role });
                formValues.push({ key: (FORM_FIELD_PUBLIC_ADMIN_WORKPLACE + i.toString()), value: this.state.publicAdminRoles[i].workplace });
                formValues.push({ key: (FORM_FIELD_PUBLIC_ADMIN_BEGIN_DATE + i.toString()), value: this.state.publicAdminRoles[i].beginDate });
                formValues.push({ key: (FORM_FIELD_PUBLIC_ADMIN_END_DATE + i.toString()), value: this.state.publicAdminRoles[i].endDate });
            }

            for (let i = 0; i < this.state.ethicsCommitteeRoles.length; i++) {
                formValues.push({ key: (FORM_FIELD_ETHICS_COMMITTEE_ROLE + i.toString()), value: this.state.ethicsCommitteeRoles[i].role });
                formValues.push({ key: (FORM_FIELD_ETHICS_COMMITTEE_WORKPLACE + i.toString()), value: this.state.ethicsCommitteeRoles[i].workplace });
                formValues.push({ key: (FORM_FIELD_ETHICS_COMMITTEE_BEGIN_DATE + i.toString()), value: this.state.ethicsCommitteeRoles[i].beginDate });
                formValues.push({ key: (FORM_FIELD_ETHICS_COMMITTEE_END_DATE + i.toString()), value: this.state.ethicsCommitteeRoles[i].endDate });
            }

            for (let i = 0; i < this.state.qualityCommitteeRoles.length; i++) {
                formValues.push({ key: (FORM_FIELD_QUALITY_COMMITTEE_ROLE + i.toString()), value: this.state.qualityCommitteeRoles[i].role });
                formValues.push({ key: (FORM_FIELD_QUALITY_COMMITTEE_WORKPLACE + i.toString()), value: this.state.qualityCommitteeRoles[i].workplace });
                formValues.push({ key: (FORM_FIELD_QUALITY_COMMITTEE_BEGIN_DATE + i.toString()), value: this.state.qualityCommitteeRoles[i].beginDate });
                formValues.push({ key: (FORM_FIELD_QUALITY_COMMITTEE_END_DATE + i.toString()), value: this.state.qualityCommitteeRoles[i].endDate });
            }

            for (let i = 0; i < this.state.organizationalRoles.length; i++) {
                formValues.push({ key: (FORM_FIELD_ORGANIZATIONAL_WORKPLACE + i.toString()), value: this.state.organizationalRoles[i].role });
                formValues.push({ key: (FORM_FIELD_ORGANIZATIONAL_BEGIN_DATE + i.toString()), value: this.state.organizationalRoles[i].beginDate });
                formValues.push({ key: (FORM_FIELD_ORGANIZATIONAL_END_DATE+ i.toString()), value: this.state.organizationalRoles[i].endDate });
            }

            this.props.updateFormStep(1, formValues, () => this.props.onNext());
        }
        else {
            this.props.updateStep8State(STEP_STATE_VALIDATION_ERROR);

            this.props.updateFormStep(1, 
                [
                    { key: FORM_STEP_8_STATE, value: STEP_STATE_VALIDATION_ERROR }
                ],
                () => {});
        }
    }

    clearComponentVariables() {
        this.setState({
            addEthicsMode: false,
            addManagementMode: false,
            addPublicAdminMode: false,
            addQualityMode: false,
            addOrganizationalMode: false,
            cursorManagementRole: "",
            cursorManagementWorkplace: "",
            cursorManagementProfessionalsNumber: "",
            cursorManagementBeginDate: null,
            cursorManagementEndDate: null,
            cursorPublicAdminRole: "",
            cursorPublicAdminWorkplace: "",
            cursorPublicAdminBeginDate: null,
            cursorPublicAdminEndDate: null,
            cursorEthicRole: "",
            cursorEthicWorkplace: "",
            cursorEthicBeginDate: null,
            cursorEthicEndDate: null,
            cursorQualityRole: "",
            cursorQualityWorkplace: "",
            cursorQualityBeginDate: null,
            cursorQualityEndDate: null,
            cursorOrganizationalWorkplace: "",
            cursorOrganizationalBeginDate: null,
            cursorOrganizationalEndDate: null,
            validBusinessName: true,
            validProfessionalsNumber: true,
            validManagementRole: true,
            validManagementProfessionalsNumber: true,
            validManagementWorkplace: true,
            validManagementBeginDate: true,
            validPublicAdminRole: true,
            validPublicAdminWorkplace: true,
            validPublicAdminBeginDate: true,
            validEthicRole: true,
            validEthicBeginDate: true,
            validEthicWorkplace: true,
            validQualityBeginDate: true,
            validQualityRole: true,
            validQualityWorkplace: true,
            validOrganizationalBeginDate: true,
            validOrganizationalWorkplace: true,
            // Management roles validation 
            validManagementRolesRole: [true, true, true],
            validManagementRolesWorkplace: [true, true, true],
            validManagementRolesBeginDate: [true, true, true],
            validManagementRolesProfessionalsNumber: [true, true, true],
            // Public admin roles validation 
            validPublicAdminRolesRole: [true, true, true],
            validPublicAdminRolesWorkplace: [true, true, true],
            validPublicAdminRolesBeginDate: [true, true, true],
            // Ethic roles validation 
            validEthicRolesRole: [true, true, true],
            validEthicRolesWorkplace: [true, true, true],
            validEthicRolesBeginDate: [true, true, true],
            // Quality roles validation 
            validQualityRolesRole: [true, true, true],
            validQualityRolesWorkplace: [true, true, true],
            validQualityRolesBeginDate: [true, true, true],
            // Organizational roles validation 
            validOrganizationalRolesWorkplace: [true, true, true, true, true, true, true, true, true, true],
            validOrganizationalRolesBeginDate: [true, true, true, true, true, true, true, true, true, true]
        });
    }

    //***********************/
    //* UPDATE ROLES        */
    //***********************/

    saveManagementData() {
        if(this.validateForm()) {
            let managementRoles = this.state.managementRoles;

            managementRoles.push({
                order: managementRoles.length + 1,
                role: this.state.cursorManagementRole,
                workplace: this.state.cursorManagementWorkplace,
                beginDate: this.state.cursorManagementBeginDate,
                endDate: this.state.cursorManagementEndDate,
                professionalsNumber: this.state.cursorManagementProfessionalsNumber,
                addManagementMode: false
            });
    
            this.setState({
                managementRoles: managementRoles
            });
        }
    }

    savePublicAdminData() {
        if(this.validateForm()) {
            let publicAdminRoles = this.state.publicAdminRoles;

            publicAdminRoles.push({
                order: publicAdminRoles.length + 1,
                role: this.state.cursorPublicAdminRole,
                workplace: this.state.cursorPublicAdminWorkplace,
                beginDate: this.state.cursorPublicAdminBeginDate,
                endDate: this.state.cursorPublicAdminEndDate,
                addPublicAdminMode: false
            });
    
            this.setState({
                publicAdminRoles: publicAdminRoles
            });
        }
    }

    saveEthicsCommitteeData() {
        if(this.validateForm()) {
            let ethicsCommitteeRoles = this.state.ethicsCommitteeRoles;

            ethicsCommitteeRoles.push({
                order: ethicsCommitteeRoles.length + 1,
                role: this.state.cursorEthicRole,
                workplace: this.state.cursorEthicWorkplace,
                beginDate: this.state.cursorEthicBeginDate,
                endDate: this.state.cursorEthicEndDate,
                addEthicsMode: false
            });
    
            this.setState({
                ethicsCommitteeRoles: ethicsCommitteeRoles
            });
        }
    }

    saveQualityCommitteeData() {
        if(this.validateForm()) {
            let qualityCommitteeRoles = this.state.qualityCommitteeRoles;

            qualityCommitteeRoles.push({
                order: qualityCommitteeRoles.length + 1,
                role: this.state.cursorQualityRole,
                workplace: this.state.cursorQualityWorkplace,
                beginDate: this.state.cursorQualityBeginDate,
                endDate: this.state.cursorQualityEndDate,
                addQualityMode: false
            });
    
            this.setState({
                qualityCommitteeRoles: qualityCommitteeRoles
            });
        }
    }

    saveOrganizationalData() {
        if(this.validateForm()) {
            let organizationalRoles = this.state.organizationalRoles;

            organizationalRoles.push({
                order: organizationalRoles.length + 1,
                workplace: this.state.cursorOrganizationalWorkplace,
                beginDate: this.state.cursorOrganizationalBeginDate,
                endDate: this.state.cursorOrganizationalEndDate,
                addOrganizationalMode: false
            });
    
            this.setState({
                organizationalRoles: organizationalRoles
            });
        }
    }

    //***********************/
    //* UPDATE ROLES        */
    //***********************/

    updateManagementRolesData(order, field, value) {
        let managementRoles = this.state.managementRoles;

        for (let i = 0; i < this.state.managementRoles.length; i++) {
            if(this.state.managementRoles[i].order === order) {
                managementRoles[i][field] = value;
            }
        }

        this.setState({
            managementRoles: managementRoles
        });
    }

    updatePublicAdminRolesData(order, field, value) {
        let publicAdminRoles = this.state.publicAdminRoles;

        for (let i = 0; i < this.state.publicAdminRoles.length; i++) {
            if(this.state.publicAdminRoles[i].order === order) {
                publicAdminRoles[i][field] = value;
            }
        }

        this.setState({
            publicAdminRoles: publicAdminRoles
        });
    }

    updateEthicRolesData(order, field, value) {
        let ethicsCommitteeRoles = this.state.ethicsCommitteeRoles;

        for (let i = 0; i < this.state.ethicsCommitteeRoles.length; i++) {
            if(this.state.ethicsCommitteeRoles[i].order === order) {
                ethicsCommitteeRoles[i][field] = value;
            }
        }

        this.setState({
            ethicsCommitteeRoles: ethicsCommitteeRoles
        });
    }

    updateQualityRolesData(order, field, value) {
        let qualityCommitteeRoles = this.state.qualityCommitteeRoles;

        for (let i = 0; i < this.state.qualityCommitteeRoles.length; i++) {
            if(this.state.qualityCommitteeRoles[i].order === order) {
                qualityCommitteeRoles[i][field] = value;
            }
        }

        this.setState({
            qualityCommitteeRoles: qualityCommitteeRoles
        });
    }

    updateOrganizationalRolesData(order, field, value) {
        let organizationalRoles = this.state.organizationalRoles;

        for (let i = 0; i < this.state.organizationalRoles.length; i++) {
            if(this.state.organizationalRoles[i].order === order) {
                organizationalRoles[i][field] = value;
            }
        }

        this.setState({
            organizationalRoles: organizationalRoles
        });
    }

    //***********************/
    //* DELETE ROLES        */
    //***********************/

    deleteManagementRole(order) {
        let managementRoles = [];

        for (let i = 0; i < this.state.managementRoles.length; i++) {
            if(this.state.managementRoles[i].order !== order) {
                let role = this.state.managementRoles[i];
                role.order = (managementRoles.length + 1);
                managementRoles.push(role);
            }
        }

        this.setState({
            managementRoles: managementRoles
        });
    }

    deletePublicAdminRole(order) {
        let publicAdminRoles = [];

        for (let i = 0; i < this.state.publicAdminRoles.length; i++) {
            if(this.state.publicAdminRoles[i].order !== order) {
                let role = this.state.publicAdminRoles[i];
                role.order = (publicAdminRoles.length + 1);
                publicAdminRoles.push(role);
            }
        }

        this.setState({
            publicAdminRoles: publicAdminRoles
        });
    }

    deleteEthicCommitteeRole(order) {
        let ethicsCommitteeRoles = [];

        for (let i = 0; i < this.state.ethicsCommitteeRoles.length; i++) {
            if(this.state.ethicsCommitteeRoles[i].order !== order) {
                let role = this.state.ethicsCommitteeRoles[i];
                role.order = (ethicsCommitteeRoles.length + 1);
                ethicsCommitteeRoles.push(role);
            }
        }

        this.setState({
            ethicsCommitteeRoles: ethicsCommitteeRoles
        });
    }

    deleteQualityCommitteeRole(order) {
        let qualityCommitteeRoles = [];

        for (let i = 0; i < this.state.qualityCommitteeRoles.length; i++) {
            if(this.state.qualityCommitteeRoles[i].order !== order) {
                let role = this.state.qualityCommitteeRoles[i];
                role.order = (qualityCommitteeRoles.length + 1);
                qualityCommitteeRoles.push(role);
            }
        }

        this.setState({
            qualityCommitteeRoles: qualityCommitteeRoles
        });
    }

    deleteOrganizationalRole(order) {
        let organizationalRoles = [];

        for (let i = 0; i < this.state.organizationalRoles.length; i++) {
            if(this.state.organizationalRoles[i].order !== order) {
                let role = this.state.organizationalRoles[i];
                role.order = (organizationalRoles.length + 1);
                organizationalRoles.push(role);
            }
        }

        this.setState({
            organizationalRoles: organizationalRoles
        });
    }

    render() {
        return (
            <>
                <div id="data-container" className="card p-fluid mgt-20">
                    <div className="grid">
                        <div className="col-12">
                            <div className="grid mgt-10">
                                <RegistrationFormStepTitleComponent title={this.props.t("registration-form.step-8.title")}
                                                                    subtitles={[ this.props.t("registration-form.step-8.subtitle-1"), this.props.t("registration-form.step-8.subtitle-2") ]} />
                                <div className='col-12 t-align-left'>
                                    <label htmlFor="businessOwner">{this.props.t("profile.areas.other.business-owner")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="businessOwner" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} value={this.state.businessOwner} options={getYesNoDropdownList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("businessOwner", evt.value)}></Dropdown>
                                </div>
                                {
                                    this.state.businessOwner.code === YES_OPTION.code ? 
                                        <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                            <label htmlFor="businessName">{this.props.t("profile.areas.other.business-name")} <span className="invalid-message">*</span></label>
                                            <InputText id="businessName" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} value={this.state.businessName} type="text" onChange={(evt) => this.updateFormComponent("businessName", evt.target.value)}/>
                                            { this.state.validBusinessName ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                        </div>
                                        : 
                                        null
                                }
                                {
                                    this.state.businessOwner.code === YES_OPTION.code ? 
                                        <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                            <label htmlFor="employeeNum">{this.props.t("profile.areas.other.employee-number")} <span className="invalid-message">*</span></label>
                                            <InputText id="employeeNum" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} value={this.state.professionalsNumber} type="number" onChange={(evt) => this.updateFormComponent("professionalsNumber", evt.target.value)}/>
                                            { this.state.validProfessionalsNumber ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                        </div>
                                        : 
                                        null
                                }
                                <div className='col-12 t-align-left'>
                                    <label htmlFor="boss">{this.props.t("profile.areas.other.management-role")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="boss" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} value={this.state.hasManagementRole} options={getYesNoDropdownList(getLanguage())} optionLabel="name"></Dropdown>
                                </div>
                                {
                                    this.state.managementRoles.map((role) => { 
                                        return <div key={role.order} className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                                    <div className='grid'>
                                                        <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                            <label htmlFor="managementRole">{this.props.t("profile.areas.other.role")} <span className="invalid-message">*</span></label>
                                                            <InputText id="managementRole" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} value={role.role} type="text" onChange={(evt) => this.updateManagementRolesData(role.order, "role", evt.target.value)} />
                                                            { this.state.validManagementRolesRole[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                        </div>
                                                        <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                            <label htmlFor="managementInstitution">{this.props.t("profile.areas.other.institution")} <span className="invalid-message">*</span></label>
                                                            <InputText id="managementInstitution" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} value={role.workplace} type="text" onChange={(evt) => this.updateManagementRolesData(role.order, "workplace", evt.target.value)} />
                                                            { this.state.validManagementRolesWorkplace[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                        </div>
                                                        <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                            <label htmlFor="managementBeginDate">{this.props.t("profile.areas.other.begin-date")} <span className="invalid-message">*</span></label>
                                                            <Calendar disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} dateFormat="dd/mm/yy" maxDate={new Date()} value={role.beginDate} showIcon showButtonBar onChange={(evt) => this.updateManagementRolesData(role.order, "beginDate", evt.target.value)} />
                                                            { this.state.validManagementRolesBeginDate[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                        </div>
                                                        <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                            <label htmlFor="managementEndDate">{this.props.t("profile.areas.other.end-date")}</label>
                                                            <Calendar disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} dateFormat="dd/mm/yy" maxDate={new Date()} value={role.endDate} showIcon showButtonBar onChange={(evt) => this.updateManagementRolesData(role.order, "endDate", evt.target.value)} />
                                                        </div>
                                                        <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                            <label htmlFor="managementEmployeeNum">{this.props.t("profile.areas.other.physio-num")} <span className="invalid-message">*</span></label>
                                                            <InputText id="managementEmployeeNum" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} value={role.professionalsNumber} type="number" onChange={(evt) => this.updateManagementRolesData(role.order, "professionalsNumber", evt.target.value)} />
                                                            { this.state.validManagementRolesProfessionalsNumber[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                        </div>
                                                        <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                            <i className="pi pi-trash c-pointer" style={{ fontSize: '1.9rem' }} title={this.props.t("general.delete")} onClick={(evt) => this.deleteManagementRole(role.order)}></i>
                                                        </div>
                                                    </div>
                                                </div>
                                    })
                                }
                                {
                                    !this.state.addManagementMode && this.state.managementRoles.length < 3 ?
                                        <div className='col-12 t-align-center'>
                                            <Button icon="pi pi-plus" className="mr-2 mb-2" style={{width: "200px"}} onClick={() => this.setManagementMode()}>
                                                <span className='mgl-10'>{this.props.t("profile.areas.other.add-role")}</span>
                                            </Button>                              
                                        </div>
                                        : null
                                }
                                {
                                    this.state.addManagementMode ?
                                        <div className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                            <div className='grid'>
                                                <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                    <label htmlFor="editManagementRole">{this.props.t("profile.areas.other.role")} <span className="invalid-message">*</span></label>
                                                    <InputText id="editManagementRole" value={this.state.cursorManagementRole} type="text" onChange={(evt) => this.setState({ cursorManagementRole: evt.target.value })} />
                                                    { this.state.validManagementRole ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                </div>
                                                <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                    <label htmlFor="editManagementInstitution">{this.props.t("profile.areas.other.institution")} <span className="invalid-message">*</span></label>
                                                    <InputText id="editManagementInstitution" value={this.state.cursorManagementWorkplace} type="text" onChange={(evt) => this.setState({ cursorManagementWorkplace: evt.target.value })} />
                                                    { this.state.validManagementWorkplace ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                </div>
                                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                    <label htmlFor="editManagementBeginDate">{this.props.t("profile.areas.other.begin-date")} <span className="invalid-message">*</span></label>
                                                    <Calendar dateFormat="dd/mm/yy" maxDate={new Date()} value={this.state.cursorManagementBeginDate} showIcon showButtonBar onChange={(evt) => this.setState({ cursorManagementBeginDate: evt.value })} />
                                                    { this.state.validManagementBeginDate ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                </div>
                                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                    <label htmlFor="editManagementEndDate">{this.props.t("profile.areas.other.end-date")}</label>
                                                    <Calendar dateFormat="dd/mm/yy" maxDate={new Date()} value={this.state.cursorManagementEndDate} showIcon showButtonBar onChange={(evt) => this.setState({ cursorManagementEndDate: evt.value })} />
                                                </div>
                                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                    <label htmlFor="editManagementEmployeeNum">{this.props.t("profile.areas.other.physio-num")} <span className="invalid-message">*</span></label>
                                                    <InputText id="editManagementEmployeeNum" value={this.state.cursorManagementProfessionalsNumber} type="number" onChange={(evt) => this.setState({ cursorManagementProfessionalsNumber: evt.target.value })} />
                                                    { this.state.validManagementProfessionalsNumber ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                </div>
                                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <i className="pi pi-save c-pointer" style={{ fontSize: '1.9rem' }} title={this.props.t("general.save")} onClick={(evt) => this.saveManagementData()}></i>
                                                <i className="pi pi-ban c-pointer" style={{ fontSize: '1.9rem' }} title={this.props.t("general.cancel")} onClick={(evt) => this.clearComponentVariables()}></i>
                                            </div>
                                            </div>
                                        </div> : null
                                }
                                <div className='col-12 t-align-left'>
                                    <label htmlFor="publicAdmin">{this.props.t("profile.areas.other.public-admin-role")} 
                                        <span className="invalid-message mgr-5">*</span>
                                        <i className="other-data-help-icon pi pi-question-circle p-text-secondary" data-pr-tooltip={this.props.t("profile.areas.other.help-messages.public-admin")} data-pr-position="right" data-pr-at="right+5 center" data-pr-my="left center-2" style={{ color:"#0073aa", fontSize:"16px", fontWeight:"bold", cursor: 'pointer' }}></i>
                                    </label>
                                    <Dropdown id="publicAdmin" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} value={this.state.hasPublicAdminRole} options={getYesNoDropdownList(getLanguage())} optionLabel="name"></Dropdown>
                                </div>
                            {
                                this.state.publicAdminRoles.map((role) => { 
                                    return <div key={role.order} className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                                <div className='grid'>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="publicAdminRole">{this.props.t("profile.areas.other.role")} <span className="invalid-message">*</span></label>
                                                        <InputText disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} id="publicAdminRole" value={role.role} type="text" onChange={(evt) => this.updatePublicAdminRolesData(role.order, "role", evt.target.value)}/>
                                                        { this.state.validPublicAdminRolesRole[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="publicAdminInstitution">{this.props.t("profile.areas.other.institution")} <span className="invalid-message">*</span></label>
                                                        <InputText disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} id="publicAdminInstitution" value={role.workplace} type="text" onChange={(evt) => this.updatePublicAdminRolesData(role.order, "workplace", evt.target.value)} />
                                                        { this.state.validPublicAdminRolesWorkplace[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="publicAdminBeginDate">{this.props.t("profile.areas.other.begin-date")} <span className="invalid-message">*</span></label>
                                                        <Calendar disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} dateFormat="dd/mm/yy" maxDate={new Date()} value={role.beginDate} showIcon showButtonBar onChange={(evt) => this.updatePublicAdminRolesData(role.order, "beginDate", evt.target.value)} />
                                                        { this.state.validPublicAdminRolesBeginDate[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="publicAdminEndDate">{this.props.t("profile.areas.other.end-date")}</label>
                                                        <Calendar disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} dateFormat="dd/mm/yy" maxDate={new Date()} value={role.endDate} showIcon showButtonBar onChange={(evt) => this.updatePublicAdminRolesData(role.order, "endDate", evt.target.value)} />
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                        <i className="pi pi-trash c-pointer" style={{ fontSize: '1.9rem' }} title={this.props.t("general.delete")} onClick={(evt) => this.deletePublicAdminRole(role.order)}></i>
                                                    </div>
                                                </div>
                                            </div>
                                })
                            }
                            {
                                !this.state.addPublicAdminMode && this.state.publicAdminRoles.length < 3 ?
                                    <div className='col-12 t-align-center'>
                                        <Button icon="pi pi-plus" className="mr-2 mb-2" style={{width: "200px"}} onClick={() => this.setPublicAdminMode()}>
                                            <span className='mgl-10'>{this.props.t("profile.areas.other.add-role")}</span>
                                        </Button>                              
                                    </div>
                                    : null
                            }
                            {
                                this.state.addPublicAdminMode ?
                                    <div className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                        <div className='grid'>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editPublicAdminRole">{this.props.t("profile.areas.other.role")} <span className="invalid-message">*</span></label>
                                                <InputText id="editPublicAdminRole" value={this.state.cursorPublicAdminRole} type="text" onChange={(evt) => this.setState({ cursorPublicAdminRole: evt.target.value })} />
                                                { this.state.validPublicAdminRole ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editPublicAdminInstitution">{this.props.t("profile.areas.other.institution")} <span className="invalid-message">*</span></label>
                                                <InputText id="editPublicAdminInstitution" value={this.state.cursorPublicAdminWorkplace} type="text" onChange={(evt) => this.setState({ cursorPublicAdminWorkplace: evt.target.value })} />
                                                { this.state.validPublicAdminWorkplace ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editPublicAdminBeginDate">{this.props.t("profile.areas.other.begin-date")} <span className="invalid-message">*</span></label>
                                                <Calendar dateFormat="dd/mm/yy" maxDate={new Date()} value={this.state.cursorPublicAdminBeginDate} showIcon showButtonBar onChange={(evt) => this.setState({ cursorPublicAdminBeginDate: evt.value })} />
                                                { this.state.validPublicAdminBeginDate ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editPublicAdminEndDate">{this.props.t("profile.areas.other.end-date")}</label>
                                                <Calendar dateFormat="dd/mm/yy" maxDate={new Date()} value={this.state.cursorPublicAdminEndDate} showIcon showButtonBar onChange={(evt) => this.setState({ cursorPublicAdminEndDate: evt.value })} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <i className="pi pi-save c-pointer" style={{ fontSize: '1.9rem' }} title={this.props.t("general.save")} onClick={(evt) => this.savePublicAdminData()}></i>
                                                <i className="pi pi-ban c-pointer" style={{ fontSize: '1.9rem' }} title={this.props.t("general.cancel")} onClick={(evt) => this.clearComponentVariables()}></i>
                                            </div>
                                        </div>
                                    </div> : null
                            }
                            <div className='col-12 t-align-left'>
                                <label htmlFor="ethic">{this.props.t("profile.areas.other.ethic-role")} <span className="invalid-message">*</span></label>
                                <Dropdown id="ethic" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} value={this.state.hasEthicsCommitteeRole} options={getYesNoDropdownList(getLanguage())} optionLabel="name"></Dropdown>
                            </div>
                            {
                                this.state.ethicsCommitteeRoles.map((role) => { 
                                    return <div key={role.order} className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                                <div className='grid'>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="ethicRole">{this.props.t("profile.areas.other.role")} <span className="invalid-message">*</span></label>
                                                        <InputText id="ethicRole" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} value={role.role} type="text" onChange={(evt) => this.updateEthicRolesData(role.order, "role", evt.target.value)} />
                                                        { this.state.validEthicRolesRole[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="ethicInstitution">{this.props.t("profile.areas.other.institution")} <span className="invalid-message">*</span></label>
                                                        <InputText id="ethicInstitution" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} value={role.workplace} type="text" onChange={(evt) => this.updateEthicRolesData(role.order, "workplace", evt.target.value)} />
                                                        { this.state.validEthicRolesWorkplace[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="ethicBeginDate">{this.props.t("profile.areas.other.begin-date")} <span className="invalid-message">*</span></label>
                                                        <Calendar disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} dateFormat="dd/mm/yy" maxDate={new Date()} value={role.beginDate} showIcon showButtonBar onChange={(evt) => this.updateEthicRolesData(role.order, "beginDate", evt.target.value)} />
                                                        { this.state.validEthicRolesBeginDate[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="ethicEndDate">{this.props.t("profile.areas.other.end-date")}</label>
                                                        <Calendar disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} dateFormat="dd/mm/yy" maxDate={new Date()} value={role.endDate} showIcon showButtonBar onChange={(evt) => this.updateEthicRolesData(role.order, "endDate", evt.target.value)} />
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                        <i className="pi pi-trash c-pointer" style={{ fontSize: '1.9rem' }} title={this.props.t("general.delete")} onClick={(evt) => this.deleteEthicCommitteeRole(role.order)}></i>
                                                    </div>
                                                </div>
                                            </div>
                                })
                            }
                            {
                                !this.state.addEthicsMode && this.state.ethicsCommitteeRoles.length < 3 ?
                                    <div className='col-12 t-align-center'>
                                        <Button icon="pi pi-plus" className="mr-2 mb-2" style={{width: "200px"}} onClick={() => this.setEthicsMode()}>
                                            <span className='mgl-10'>{this.props.t("profile.areas.other.add-role")}</span>
                                        </Button>                              
                                    </div>
                                    : null
                            }
                            {
                                this.state.addEthicsMode ?
                                    <div className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                        <div className='grid'>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editEthicRole">{this.props.t("profile.areas.other.role")} <span className="invalid-message">*</span></label>
                                                <InputText id="editEthicRole" value={this.state.cursorEthicRole} type="text" onChange={(evt) => this.setState({ cursorEthicRole: evt.target.value })} />
                                                { this.state.validEthicRole ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editEthicInstitution">{this.props.t("profile.areas.other.institution")} <span className="invalid-message">*</span></label>
                                                <InputText id="editEthicInstitution" value={this.state.cursorEthicWorkplace} type="text" onChange={(evt) => this.setState({ cursorEthicWorkplace: evt.target.value })} />
                                                { this.state.validEthicWorkplace ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editEthicBeginDate">{this.props.t("profile.areas.other.begin-date")} <span className="invalid-message">*</span></label>
                                                <Calendar dateFormat="dd/mm/yy" maxDate={new Date()} value={this.state.cursorEthicBeginDate} showIcon showButtonBar onChange={(evt) => this.setState({ cursorEthicBeginDate: evt.value })} />
                                                { this.state.validEthicBeginDate ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editEthicEndDate">{this.props.t("profile.areas.other.end-date")}</label>
                                                <Calendar dateFormat="dd/mm/yy" maxDate={new Date()} value={this.state.cursorEthicEndDate} showIcon showButtonBar onChange={(evt) => this.setState({ cursorEthicEndDate: evt.value })} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <i className="pi pi-save c-pointer" style={{ fontSize: '1.9rem' }} title={this.props.t("general.save")} onClick={(evt) => this.saveEthicsCommitteeData()}></i>
                                                <i className="pi pi-ban c-pointer" style={{ fontSize: '1.9rem' }} title={this.props.t("general.cancel")} onClick={(evt) => this.clearComponentVariables()}></i>
                                            </div>
                                        </div>
                                    </div> : null
                            }
                            <div className='col-12 t-align-left'>
                                <label htmlFor="quality">{this.props.t("profile.areas.other.quality-role")} <span className="invalid-message">*</span></label>
                                <Dropdown id="quality" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} value={this.state.hasQualityCommitteRole} options={getYesNoDropdownList(getLanguage())} optionLabel="name"></Dropdown>
                            </div>
                            {
                                this.state.qualityCommitteeRoles.map((role) => { 
                                    return <div key={role.order} className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                                <div className='grid'>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="qualityRole">{this.props.t("profile.areas.other.role")} <span className="invalid-message">*</span></label>
                                                        <InputText id="qualityRole" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} value={role.role} type="text" onChange={(evt) => this.updateQualityRolesData(role.order, "role", evt.target.value)} />
                                                        { this.state.validQualityRolesRole[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="qualityInstitution">{this.props.t("profile.areas.other.institution")} <span className="invalid-message">*</span></label>
                                                        <InputText id="qualityInstitution" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} value={role.workplace} type="text" onChange={(evt) => this.updateQualityRolesData(role.order, "workplace", evt.target.value)} />
                                                        { this.state.validQualityRolesWorkplace[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="qualityBeginDate">{this.props.t("profile.areas.other.begin-date")} <span className="invalid-message">*</span></label>
                                                        <Calendar disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} dateFormat="dd/mm/yy" maxDate={new Date()} value={role.beginDate} showIcon showButtonBar onChange={(evt) => this.updateQualityRolesData(role.order, "beginDate", evt.target.value)} />
                                                        { this.state.validQualityRolesBeginDate[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="qualityEndDate">{this.props.t("profile.areas.other.end-date")}</label>
                                                        <Calendar disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} dateFormat="dd/mm/yy" maxDate={new Date()} value={role.endDate} showIcon showButtonBar onChange={(evt) => this.updateQualityRolesData(role.order, "endDate", evt.target.value)} />
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                        <i className="pi pi-trash c-pointer" style={{ fontSize: '1.9rem' }} title={this.props.t("general.delete")} onClick={(evt) => this.deleteQualityCommitteeRole(role.order)}></i>
                                                    </div>
                                                </div>
                                            </div>
                                }) 
                            }
                            {
                                !this.state.addQualityMode && this.state.qualityCommitteeRoles.length < 3 ?
                                    <div className='col-12 t-align-center'>
                                        <Button icon="pi pi-plus" className="mr-2 mb-2" style={{width: "200px"}} onClick={() => this.setQualityMode()}>
                                            <span className='mgl-10'>{this.props.t("profile.areas.other.add-role")}</span>
                                        </Button>                              
                                    </div>
                                    : null
                            }
                            {
                                this.state.addQualityMode ?
                                    <div className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                        <div className='grid'>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editQualityRole">{this.props.t("profile.areas.other.role")} <span className="invalid-message">*</span></label>
                                                <InputText id="editQualityRole" value={this.state.cursorQualityRole} type="text" onChange={(evt) => this.setState({ cursorQualityRole: evt.target.value })} />
                                                { this.state.validQualityRole ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editQualityInstitution">{this.props.t("profile.areas.other.institution")} <span className="invalid-message">*</span></label>
                                                <InputText id="editQualityInstitution" value={this.state.cursorQualityWorkplace} type="text" onChange={(evt) => this.setState({ cursorQualityWorkplace: evt.target.value })} />
                                                { this.state.validQualityWorkplace ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editQualityBeginDate">{this.props.t("profile.areas.other.begin-date")} <span className="invalid-message">*</span></label>
                                                <Calendar dateFormat="dd/mm/yy" maxDate={new Date()} value={this.state.cursorQualityBeginDate} showIcon showButtonBar onChange={(evt) => this.setState({ cursorQualityBeginDate: evt.value })} />
                                                { this.state.validQualityBeginDate ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editQualityEndDate">{this.props.t("profile.areas.other.end-date")}</label>
                                                <Calendar dateFormat="dd/mm/yy" maxDate={new Date()} value={this.state.cursorQualityEndDate} showIcon showButtonBar onChange={(evt) => this.setState({ cursorQualityEndDate: evt.value })} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <i className="pi pi-save c-pointer" style={{ fontSize: '1.9rem' }} title={this.props.t("general.save")} onClick={(evt) => this.saveQualityCommitteeData()}></i>
                                                <i className="pi pi-ban c-pointer" style={{ fontSize: '1.9rem' }} title={this.props.t("general.cancel")} onClick={(evt) => this.clearComponentVariables()}></i>
                                            </div>
                                        </div>
                                    </div> : null
                            }
                            <div className='col-12 t-align-left'>
                                <span><b>{this.props.t("profile.areas.other.professional-competency")}</b></span>
                            </div>
                            <div className='col-12 t-align-left'>
                                <label htmlFor="volunteer">{this.props.t("profile.areas.other.volunteer-role")} <span className="invalid-message">*</span></label>
                                <Dropdown id="volunteer" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} value={this.state.hasOrganizationalRole} options={getYesNoDropdownList(getLanguage())} optionLabel="name"></Dropdown>
                            </div>
                            {
                                this.state.organizationalRoles.map((role) => { 
                                    return <div key={role.order} className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                                <div className='grid'>
                                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                        <label htmlFor="volunteerInstitution">{this.props.t("profile.areas.other.institution")} <span className="invalid-message">*</span></label>
                                                        <InputText id="volunteerInstitution" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} value={role.workplace} type="text" onChange={(evt) => this.updateOrganizationalRolesData(role.order, "workplace", evt.target.value)} />
                                                        { this.state.validOrganizationalRolesWorkplace[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                        <label htmlFor="volunteerBeginDate">{this.props.t("profile.areas.other.begin-date")} <span className="invalid-message">*</span></label>
                                                        <Calendar disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} dateFormat="dd/mm/yy" maxDate={new Date()} value={role.beginDate} showIcon showButtonBar onChange={(evt) => this.updateOrganizationalRolesData(role.order, "beginDate", evt.target.value)} />
                                                        { this.state.validOrganizationalRolesBeginDate[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                        <label htmlFor="volunteerEndDate">{this.props.t("profile.areas.other.end-date")}</label>
                                                        <Calendar disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} dateFormat="dd/mm/yy" maxDate={new Date()} value={role.endDate} showIcon showButtonBar onChange={(evt) => this.updateOrganizationalRolesData(role.order, "endDate", evt.target.value)} />
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                        <i className="pi pi-trash c-pointer" style={{ fontSize: '1.9rem' }} title={this.props.t("general.delete")} onClick={(evt) => this.deleteOrganizationalRole(role.order)}></i>
                                                    </div>
                                                </div>
                                            </div>
                                })
                            }
                            {
                                !this.state.addOrganizationalMode && this.state.organizationalRoles.length < 10 ?
                                    <div className='col-12 t-align-center'>
                                        <Button icon="pi pi-plus" className="mr-2 mb-2" style={{width: "200px"}} onClick={() => this.setOrganizationalMode()}>
                                            <span className='mgl-10'>{this.props.t("profile.areas.other.add-role")}</span>
                                        </Button>                              
                                    </div>
                                    : null
                            }
                            {
                                this.state.addOrganizationalMode ?
                                    <div className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                        <div className='grid'>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="editOrganizationalInstitution">{this.props.t("profile.areas.other.institution")} <span className="invalid-message">*</span></label>
                                                <InputText id="editOrganizationalInstitution" value={this.state.cursorOrganizationalWorkplace} type="text" onChange={(evt) => this.setState({ cursorOrganizationalWorkplace: evt.target.value })} />
                                                { this.state.validOrganizationalWorkplace ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="editOrganizationalBeginDate">{this.props.t("profile.areas.other.begin-date")} <span className="invalid-message">*</span></label>
                                                <Calendar dateFormat="dd/mm/yy" maxDate={new Date()} value={this.state.cursorOrganizationalBeginDate} showIcon showButtonBar onChange={(evt) => this.setState({ cursorOrganizationalBeginDate: evt.value })} />
                                                { this.state.validOrganizationalBeginDate ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="editOrganizationalEndDate">{this.props.t("profile.areas.other.end-date")}</label>
                                                <Calendar dateFormat="dd/mm/yy" maxDate={new Date()} value={this.state.cursorOrganizationalEndDate} showIcon showButtonBar onChange={(evt) => this.setState({ cursorOrganizationalEndDate: evt.value })} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <i className="pi pi-save c-pointer" style={{ fontSize: '1.9rem' }} title={this.props.t("general.save")} onClick={(evt) => this.saveOrganizationalData()}></i>
                                                <i className="pi pi-ban c-pointer" style={{ fontSize: '1.9rem' }} title={this.props.t("general.cancel")} onClick={(evt) => this.clearComponentVariables()}></i>
                                            </div>
                                        </div>
                                    </div> : null
                            }
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION ?
                        <div className="mgt-20">
                            <div className="grid">
                                <div className="col-4 t-align-left mgt-10">
                                    <Button label={this.props.t("general.back")} severity="info" raised outlined onClick={(evt) => this.props.onBack()} />
                                </div> 
                                <div className="col-4 t-align-center mgt-10">
                                    <Button icon="pi pi-question-circle" severity='success' label="Verificar passo 8" raised />
                                </div> 
                                <div className="col-4 t-align-right mgt-10">
                                    <Button label={this.props.t("general.next")} severity="info" raised outlined onClick={(evt) => this.props.onNext()} />
                                </div> 
                            </div>
                        </div>
                        : null
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        registrationState: state.authentication.registrationState,
        formFields: state.form.formFields,
        language: state.profile.language
    } 
};
  
const mapDispatchToProps = (dispatch) => {
    return {
        updateFormStep: (stepFields) => { dispatch(updateFormStep(stepFields)) },
        updateStep8State: (state) => { dispatch(updateStep8State(state)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(RegistrationFormStep8Component));